module.exports = __webpack_public_path__ + "static/media/smstocontrol4.e1d73074.png";